import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import type { Hotel, Ota } from 'frontend-utils/models';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';
import type { Day, Period } from 'lumen/models';

interface ParityTablesCellsTdPosLinkoutSignature {
  Args: {
    cellData: Period;
  };
}

export default class ParityTablesCellsTdPosLinkout extends Component<ParityTablesCellsTdPosLinkoutSignature> {
  @service declare ajax: Services['ajax'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare store: Services['store'];

  get day(): Day {
    return this.period.day;
  }

  get hotel(): Hotel | null {
    return this.hotelAndMarketService.hotel;
  }

  get linkoutURL(): string {
    // @ts-expect-error: Object is possibly 'undefined'.
    const rowOtaId = this.period.parities[0].ota;

    if (rowOtaId) {
      // Check if this OTA has support for screenshots or not
      const ota = this.store.peekRecord<Ota>('ota', rowOtaId);
      // @ts-expect-error: 'ota' is possibly 'null'.
      if (ota.hasScreenshots) {
        return `${this.ajax.host}/geoinsight/?subscriptionId=${
          this.hotel?.id
        }&fromDate=${dayjs.utc(this.day.date).format('YYYY-MM-DD')}&toDate=${dayjs
          .utc(this.day.date)
          .add(1, 'day')
          .format('YYYY-MM-DD')}`;
      }
    }

    return generateOtaLink(
      rowOtaId,
      // @ts-expect-error: Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | number'.
      this.hotel?.hotelinfo?.id,
      this.hotel?.id,
      this.hotel?.isTripadvisorRebranding,
      (this.day?.periods ?? [])[0],
      this.hotel?.defaultPersons,
      'app_parity',
      '',
      this.period.pos,
    );
  }

  get period(): Period {
    return this.args.cellData;
  }

  <template>
    <div class="flex items-center justify-end">
      <a
        data-event-id="parity-pos-table-geoinsight-redirect-link"
        href={{this.linkoutURL}}
        rel="noopener noreferrer"
        target="_blank"
      >
        <PrismButton @buttonType="secondary" @icon="view-live" @size="small" />
      </a>
    </div>
  </template>
}
